import React from 'react';
import Page from 'structure/page';
import { CONTACT_US_CLICK, SOCIAL_LINK_CLICK } from 'util/events';



export const About = (props) => {
  const emailEvent = () => props.onEvent(CONTACT_US_CLICK());

  const [ facebookEvent, twitterEvent, livejournalEvent ] = ['Facebook', 'Twiiter', 'LiveJournal'].map(type =>
    () => props.onEvent(SOCIAL_LINK_CLICK(type))
  );

  return (
    <Page title='Contacting Creative Corsetry' {...props} >
      <p>
      Creative Corsetry is a small business located in Canberra,
      Australia (ABN 51 500 500 474). We can be contacted via the following means
      </p>
      <p><strong>Email: </strong><a onClick={emailEvent} href="mailto:info@creativecorsetry.com">info@creativecorsetry.com</a></p>
      <p>Or you can follow us online, at <a onClick={livejournalEvent} href="http://creativcorsetry.livejournal.com">LiveJournal</a>
      , <a onClick={twitterEvent} href="http://twitter.com/creativcorsetry">Twitter</a>
       , and  <a onClick={facebookEvent} href="http://www.facebook.com/home.php#/pages/Creative-Corsetry/92857158212">Facebook</a>.
      </p>
    </Page>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/about/about.js